import React, { useState, useMemo } from 'react';
import { Table, Badge } from 'antd';
import IconButton from '@mui/material/IconButton';
import { DoneOutlined, CloseOutlined, VisibilityRounded } from "@mui/icons-material";
import { stringMixin } from "../../../utils/strings";

const reformatData = (data) => {
    const metrics = {};
    Object.entries(data).forEach(([key, value]) => {
        const match = key.match(/^(.+?)_(\d_yr)$/);
        if (match) {
            const [, metric, timeframe] = match;
            if (!metrics[metric]) {
                metrics[metric] = { metric };
            }
            metrics[metric][timeframe] = stringMixin.pct(value);
        }
    });
    return Object.values(metrics);
};

const BenchmarkMetrics = ({ benchmarkMetrics, editMode = true }) => {
    const [clearedCells, setClearedCells] = useState({});

    const formattedData = useMemo(() => reformatData(benchmarkMetrics), [benchmarkMetrics]);

    const toggleCellVisibility = (metric, timeframe) => {
        setClearedCells(prev => ({
            ...prev,
            [`${metric}_${timeframe}`]: !prev[`${metric}_${timeframe}`]
        }));
    };

    const renderCell = (text, record, timeframe) => {
        const cellKey = `${record.metric}_${timeframe}`;
        const isCleared = clearedCells[cellKey];

        if (!editMode) {
            return !isCleared ? text : null;
        }

        return (
            <Badge
                count={
                    <IconButton
                        size="small"
                        onClick={() => toggleCellVisibility(record.metric, timeframe)}
                        color={isCleared ? 'success' : 'error'}
                        style={isCleared?{margin: '8px'} : {}}
                    >
                        {isCleared ? <VisibilityRounded sx={{fontSize: '24px', marginLeft: '20px'}} /> : <CloseOutlined sx={{fontSize: '12px'}} />}
                    </IconButton>
                }

            >
                <span style={{ marginRight: '8px', fontSize: '12px' }}>{!isCleared ? text : ''}</span>
            </Badge>
        );
    };

    const columns = [
        {
            title: 'Metric',
            dataIndex: 'metric',
            key: 'metric',
        },
        {
            title: '1 Year',
            dataIndex: '1_yr',
            key: '1_yr',
            render: (text, record) => renderCell(text, record, '1_yr'),
            align: 'center',
        },
        {
            title: '3 Year',
            dataIndex: '3_yr',
            key: '3_yr',
            render: (text, record) => renderCell(text, record, '3_yr'),
            align: 'center',
        },
        {
            title: '5 Year',
            dataIndex: '5_yr',
            key: '5_yr',
            render: (text, record) => renderCell(text, record, '5_yr'),
            align: 'center',
        },
    ];

    const filteredData = useMemo(() => {
        if (editMode) return formattedData;
        return formattedData.filter(record =>
            !['1_yr', '3_yr', '5_yr'].every(timeframe =>
                clearedCells[`${record.metric}_${timeframe}`]
            )
        );
    }, [formattedData, clearedCells, editMode]);

    return (
        <Table
            className={'gapless mid'}
            dataSource={filteredData}
            columns={columns}
            pagination={false}
            rowKey="metric"
        />
    );
};

export default BenchmarkMetrics;